<template>
  <md-field class="relative">
    <div class="w-full">
      <label>{{ $t(label) }}</label>
      <md-input
        value="none"
        class="w-full invisible"
        :required="required"
      ></md-input>
      <slot></slot>
    </div>
    <v-select
      v-model="selected"
      :options="options"
      :reduce="option => option.id"
      label="name"
      :filterable="false"
      :noDrop="disable"
      :clearable="false"
      @search="onSearch"
      @option:selected="getValue($event)"
      class="select-filter absolute w-full"
      ref="selectFilter"
    >
      <template slot="no-options">
        {{ $t("common.no_results") }}
      </template>
    </v-select>
  </md-field>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "select-filter",
  components: { vSelect },
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    value: Object, // format: { id: 57, name: "Music" }
    options: Array,
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {},
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        return value;
      }
    }
  },
  watch: {
    selected(newValue) {
      if (!newValue) {
        this.$emit("update:value", null);
      }
    }
  },
  created() {
    this.onSearch();
  },
  methods: {
    onSearch(searchKey) {
      this.$emit("get-options", searchKey);
    },
    getValue(event) {
      this.$emit("update:value", event);
    }
  }
};
</script>
<style lang="scss">
.v-select {
  .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .dropdown li:last-child {
    border-bottom: none;
  }

  .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .dropdown-menu .active > a {
    color: #fff;
  }

  &.select-filter {
    .vs__dropdown-toggle {
      border: none;
    }

    .vs__selected-options,
    .vs__selected {
      padding: 0 !important;
      font-weight: 400;
    }

    .vs__selected-options {
      width: 100%;
    }

    .vs__selected {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 90%;
    }
  }
}
</style>
